export default __webpack_public_path__ + "static/media/omnichannel.21d537dc.png";